import { inject, Injectable } from '@angular/core';
import {
  type CreateWorkspaceRoleInput,
  type DestroyWorkspaceRoleInput,
  type UpdateWorkspaceRoleInput,
  type WorkspaceRoleFragmentFragment,
} from '@reconcept-platform/shared/types';
import { WorkspaceRoleApi } from '../../api/workspace-role/workspace-role-api.service';
import { WorkspaceRoleAccessLevelEnum } from '../../schema/schema-enums';

export function determineIsLastManageWorkspaceRole(role: WorkspaceRoleFragmentFragment): boolean {
  if (role.accessLevel === WorkspaceRoleAccessLevelEnum.MANAGE) {
    return (
      role.workspace.workspaceRoles.edges
        .map((role) => role.node)
        // @ts-expect-error TS18049 possibly null or undefined
        .map((otherRole) => otherRole.accessLevel)
        .filter((workspaceAccessLevel) => workspaceAccessLevel === WorkspaceRoleAccessLevelEnum.MANAGE).length === 1
    );
  } else {
    return false;
  }
}

@Injectable({
  providedIn: 'root',
})
export class WorkspaceRoleService {
  private roleApi = inject(WorkspaceRoleApi);

  watchWorkspaceRole(roleId: string) {
    return this.roleApi.watchWorkspaceRole(roleId);
  }

  createWorkspaceRole(createWorkspaceRoleInput: CreateWorkspaceRoleInput) {
    return this.roleApi.createWorkspaceRole(createWorkspaceRoleInput);
  }

  updateWorkspaceRole(updateWorkspaceRoleInput: UpdateWorkspaceRoleInput) {
    return this.roleApi.updateWorkspaceRole(updateWorkspaceRoleInput);
  }

  destroyWorkspaceRole(
    destroyWorkspaceRoleInput: DestroyWorkspaceRoleInput,
    workspaceId: string,
    parentDashboardId?: string,
  ) {
    return this.roleApi.destroyWorkspaceRole(destroyWorkspaceRoleInput, workspaceId, parentDashboardId);
  }
}
